import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ZuiMaterialStackModule } from '@zerops/zui/material-stack';
import { DynamicPopAnchorModule } from '@zerops/zui/dynamic-pop-anchor';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { SatPopoverModule } from '@zerops/zef/popover';
import { RoutingLocationItemModule } from '@zerops/zui/routing-location-item';
import { DnsCheckStatusIconModule } from '@zerops/zui/dns-check-status-icon';
import { RelativeTimeComponent } from '@zerops/zui/relative-time';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { HttpRoutingItemComponent } from './http-routing-item.component';
import { HttpRoutingItemTranslationsModule } from './http-routing-item.translations';
import { BadgeDetailPopoverComponent } from './badge-detail-popover/badge-detail-popover.component';

@NgModule({
  declarations: [ HttpRoutingItemComponent ],
  imports: [
    CommonModule,
    ZuiMaterialStackModule,
    DynamicPopAnchorModule,
    MatTooltipModule,
    MatButtonModule,
    ZuiSeparatorComponent,
    HttpRoutingItemTranslationsModule,
    RoutingLocationItemModule,
    SatPopoverModule,
    DnsCheckStatusIconModule,
    RelativeTimeComponent,
    ZefProgressErrorModule,
    BadgeDetailPopoverComponent
  ],
  exports: [ HttpRoutingItemComponent ]
})
export class HttpRoutingItemModule {

}
